import { useSyncExternalStore } from "react";

export type Theme = "light" | "dark";

export function applyTheme(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem("forma.theme", theme);
  } catch {
    /* ignore */
  }
}

const read = (): Theme => (document.documentElement.dataset.theme === "light" ? "light" : "dark");

function subscribe(listener: () => void) {
  const observer = new MutationObserver(listener);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
  return () => observer.disconnect();
}

/** Same approach as the desktop app: one data-theme attribute drives CSS without remounting. */
export function useTheme(): Theme {
  return useSyncExternalStore(subscribe, read, () => "dark");
}
